import script from "./pchome.vue?vue&type=script&setup=true&lang=js"
export * from "./pchome.vue?vue&type=script&setup=true&lang=js"

import "./pchome.vue?vue&type=style&index=0&id=3e5fc5b0&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e5fc5b0"]])

export default __exports__